import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { RestricaoContrato } from "app/models/restricao-contrato";
import { RestricaoContratoTipo } from 'app/models/restricao-contrato-tipo';
import { EspecialidadePorEncaminhamento } from 'app/models/restricao-especialidade';
import { RestricaoIdade } from "app/models/restricao-idade";
import { TeleconsultaRestricaoContratoTipoRequest } from 'app/models/teleconsultaRestricaoContratoTipoRequest';
import { TeleconsultaEspecialidadePorEncaminhamentoRequest } from 'app/models/teleconsultaRestricaoEspecialidadeEncRequest';
import { TelemediciaRestricaoContratoRequest } from "app/models/telemediciaRestricaoContratoRequest";
import { TelemediciaRestricaoIdadeRequest } from "app/models/telemediciaRestricaoIdadeRequest";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class RestricaoTeleconsultaService {
   private API_URL: string = environment.apiUrl;

   constructor(
      private http: Http,
   ) { }

   obterRestricoesIdade(): Observable<RestricaoIdade[]> {
      return this.http.get(this.API_URL + 'RestricaoIdadeTeleconsulta')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   obterRestricoesContrato(): Observable<RestricaoContrato[]> {
      return this.http.get(this.API_URL + 'RestricaoContratoTeleconsulta')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   obterRestricoesContratoTipo(): Observable<RestricaoContratoTipo[]> {
      return this.http.get(this.API_URL + 'RestricaoContratoTipoTeleconsulta')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   obterRestricoesEspecialidadeEncaminhamento(): Observable<EspecialidadePorEncaminhamento[]> {
      return this.http.get(this.API_URL + 'TeleconsultaEspecialidadeEncaminhamento')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   public salvarRestricaoIdade(data: TelemediciaRestricaoIdadeRequest) {

      let url = `${this.API_URL}RestricaoIdadeTeleconsulta`;
      return this.http.post(url, data).map(
         res => res.json(),
         error => error.json()
      );
   }

   public salvarRestricaoContrato(data: TelemediciaRestricaoContratoRequest) {

      let url = `${this.API_URL}RestricaoContratoTeleconsulta`;
      return this.http.post(url, data).map(
         res => res.json(),
         error => error.json()
      );
   }

   public salvarRestricaoContratoTipo(data: TeleconsultaRestricaoContratoTipoRequest) {
      const url = `${this.API_URL}RestricaoContratoTipoTeleconsulta`;
      return this.http.post(url, data).map(
         res => res.json(),
         error => error.json()
      );
   }

   public salvarRestricoesEspecialidadeEncaminhamento(data: TeleconsultaEspecialidadePorEncaminhamentoRequest) {
      const url = `${this.API_URL}TeleconsultaEspecialidadeEncaminhamento`;
      return this.http.post(url, data).map(
         res => res.json(),
         error => error.json()
      );
   }

}



// WEBPACK FOOTER //
// ./src/app/app-services/restricao-teleconsulta.service.ts